
import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { CachedDataService } from '@services/data/cached-data.service';
import { ScreenService } from '@services/screen.service';
@Injectable()
export class PersonalGuard implements CanActivate {
    currentUrl: String = null;
    constructor(
        private router: Router,
        private screenService: ScreenService,
        private cachedDataService: CachedDataService) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.cachedDataService.getExpiredDate()) {
            this.cachedDataService.clearCache();
            this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url }});
            return false;
        }
        if (this.cachedDataService.isAuth()) {
            if (this.cachedDataService.getCurrentUser() && !this.cachedDataService.getCurrentUser().phoneNumberConfirmed){
                this.screenService.isShowLoader = false;
                this.router.navigate(['/signup']);
                return false;
            } else {
                return true;
            }
        } else {
            this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url }});
            return false;
        }
    }
}






// WEBPACK FOOTER //
// ./src/app/guards/personal.guard.ts